import type { SearchApiResponse } from '../api/rest/types';

export function extractPageTrackingInformation(apiResponse: SearchApiResponse) {
  const { searchId } = apiResponse.searchresult.information;
  const { majorMkz } = apiResponse.searchresult.result;

  // TODO i18n, currently only german
  const categoryPath = apiResponse.searchresult.result?.navigation?.breadCrumb?.map((item) => ({
    id: item.id,
    name: item.name === 'Startseite' ? 'storefront' : item.name,
  }));

  const { landmarkUrls } = apiResponse.searchresult.information ?? {};

  return {
    searchId,
    majorMkz,
    categoryPath,
    landmarkUrls,
  };
}
